import { ArrowUp } from "@phosphor-icons/react";

export default function Footer() {
    return (
        <footer className="border-t border-white/10 px-5 py-16 md:px-10" data-testid="footer">
            <div className="grid gap-12 md:grid-cols-12">
                <div className="md:col-span-5">
                    <p className="font-display text-4xl uppercase leading-[0.95] tracking-tight md:text-5xl" data-testid="footer-wordmark">
                        Akash <span className="text-blaze">Group</span>
                    </p>
                    <p className="mt-5 max-w-xs text-sm leading-relaxed text-white/45">
                        Container transport, heavy machinery haulage and freight forwarding — across India, on time, every time.
                    </p>
                </div>
                <div className="md:col-span-3">
                    <p className="mb-5 text-[11px] uppercase tracking-[0.25em] text-white/40">Group companies</p>
                    <ul className="space-y-3 text-sm text-white/65" data-testid="footer-companies">
                        <li>Akash Cargo Movers</li>
                        <li>Anshika Roadlines</li>
                        <li>Akash Logistics India</li>
                    </ul>
                </div>
                <div className="md:col-span-4">
                    <p className="mb-5 text-[11px] uppercase tracking-[0.25em] text-white/40">Reach us</p>
                    <ul className="space-y-3 text-sm text-white/65">
                        <li><a href="tel:+919711220094" className="transition-colors duration-200 hover:text-blaze" data-testid="footer-phone">+91 97112 20094</a></li>
                        <li><a href="mailto:akashcargomovers@gmail.com" className="transition-colors duration-200 hover:text-blaze" data-testid="footer-email">akashcargomovers@gmail.com</a></li>
                        <li data-testid="footer-address">F26-B, Gali No.2, Molarband Extension, Badarpur, New Delhi-110044</li>
                    </ul>
                </div>
            </div>
            <div className="mt-16 flex flex-wrap items-center justify-between gap-6 border-t border-white/10 pt-8">
                <p className="text-[11px] uppercase tracking-[0.2em] text-white/30" data-testid="footer-copyright">
                    © 2026 Akash Group of Companies. All rights reserved.
                </p>
                <a
                    href="#top"
                    data-testid="footer-back-to-top"
                    className="group flex items-center gap-2 text-[11px] uppercase tracking-[0.25em] text-white/50 transition-colors duration-200 hover:text-blaze"
                >
                    Back to top
                    <ArrowUp size={14} weight="bold" className="transition-transform duration-200 group-hover:-translate-y-0.5" />
                </a>
            </div>
        </footer>
    );
}
